import './index.css';
import React from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import ReactDOM from 'react-dom';
import Cookies from 'universal-cookie';
import { getOrCreateStore } from './store/withReduxStore';
import createHttp from './utils/http';
import * as serviceWorker from './serviceWorker';
import AppContext from './utils/appContext';
import LoadingSpinner from './components/Suspense';
import App from './App';

const http = createHttp();
const cookies = new Cookies();
const context = { cookies, http };
const reduxStore = getOrCreateStore({}, context);

ReactDOM.render(
  <AppContext.Provider value={context}>
    <ReduxProvider store={reduxStore}>
      <LoadingSpinner>
        <App />
      </LoadingSpinner>
    </ReduxProvider>
  </AppContext.Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
